/* eslint-disable */
import regex from '@/services/regex';

const validateCnpj = cnpj => {
    return regex.cnpj.test(cnpj);
};

const validateUrl = url => {
    return regex.url.test(url);
};

const isNullOrEmptyString = str => {
    return !str || str.trim() === '';
};

export default {
    validateCnpj,
    validateUrl,
    isNullOrEmptyString
}